<div
    class="relative min-w-[400px] overflow-hidden rounded-xl border px-6 py-4"
    [ngClass]="{
        'border-slate-100 bg-white text-gray-700': type === 'info',
        'border-blue-200 bg-blue-50 text-blue-700': type === 'primary',
        'border-green-200 bg-green-50 text-green-700': type === 'success',
        'border-orange-200 bg-orange-50 text-orange-700': type === 'warning',
        'border-red-200 bg-red-50 text-red-700': type === 'danger',
    }"
>
    <i class="fa-solid fa-xmark absolute right-2 top-2 cursor-pointer p-1" (click)="remove()"></i>
    <div class="flex gap-4">
        <div>
            @if (icon) {
                <i class="{{ icon }}"></i>
            } @else {
                <i
                    class="fa-solid"
                    [ngClass]="{
                        'fa-info-circle': type === 'info' || type === 'primary',
                        'fa-circle-check': type === 'success',
                        'fa-triangle-exclamation': type === 'warning',
                        'fa-circle-exclamation': type === 'danger',
                    }"
                ></i>
            }
        </div>
        <div class="pr-6">
            @if (title) {
                <h4 class="mb-1 font-semibold">{{ title }}</h4>
            }
            <p class="text-sm">{{ message }}</p>
            <ng-content></ng-content>
        </div>
    </div>
</div>
